import type { PaymentMethod } from '@/types/api';

/** "Visa •••• 4242" — brand-cased + masked last4. */
export function cardLabel(pm: PaymentMethod): string {
  const brand = pm.brand
    ? pm.brand.charAt(0).toUpperCase() + pm.brand.slice(1)
    : 'Card';
  const last4 = pm.last4 ? `•••• ${pm.last4}` : '';
  return `${brand} ${last4}`.trim();
}

/** "exp 04/27" or null when expiry is unknown. */
export function cardExpiry(pm: PaymentMethod): string | null {
  if (!pm.exp_month || !pm.exp_year) return null;
  return `exp ${String(pm.exp_month).padStart(2, '0')}/${String(pm.exp_year).slice(-2)}`;
}
